import * as index from '@syncfusion/ej2-filemanager';
index.FileManager.Inject( index.DetailsView,index.NavigationPane,index.LargeIconsView,index.Toolbar,index.ContextMenu,index.BreadCrumbBar);
export * from '@syncfusion/ej2-filemanager';
